<template>
    <div class="d-flex">
        <div class="chooseBtn btn tertiary d-flex flex-column" :class="{'border-color-1': useExistingAgent}" @click="setButton(true)">
            <span class="mb-2 bold">New Agent</span>
            <span class="fs-smallest">Agent not yet in your network</span>
        </div>

        <div class="chooseBtn btn tertiary d-flex flex-column" :class="{'border-color-1': !useExistingAgent}" @click="setButton(false)">
            <span class="mb-2 bold">Existing Agent</span>
            <span class="fs-smallest">Link to an existing offline agent</span>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import extendedVSelect from '@/extends/vue-select'

export default {
    data() {
        return {
            useExistingAgent: true
        }
    },
    props: {
        value: {
            type: Boolean
        }
    },
    methods: {
        setButton(val) {
            this.useExistingAgent = val;
            this.$emit('valueChanged', !val);
            this.$emit('input', true);
        }
    },
    components: {
        vSelect: extendedVSelect
    }
}
</script>

<style lang="scss" scoped>
    .chooseBtn {
        line-height: normal;
        height: 80px;
        width: 190px;
        margin-right: 0.5rem;

        &.border-color-1 {
            border-width: 2px !important;
        }
    }
</style>



// WEBPACK FOOTER //
// AgentExistingSelector.vue?4a3b15ba